import { render, staticRenderFns } from "./peopleAnJianTemple.vue?vue&type=template&id=15a7d27e&scoped=true"
import script from "./peopleAnJianTemple.vue?vue&type=script&lang=js"
export * from "./peopleAnJianTemple.vue?vue&type=script&lang=js"
import style0 from "./peopleAnJianTemple.vue?vue&type=style&index=0&id=15a7d27e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a7d27e",
  null
  
)

export default component.exports